import { Download, Copy, Share2 } from 'lucide-react'
import { Button } from '../ui/Button'
import { toast } from 'sonner'
import { copyText, shareWithWebApi, downloadDataUrl, dataUrlToFile } from '../../lib/marketing/share'

type ShareCenterProps = {
  caption?: string
  imageDataUrl?: string
  filename?: string
  onDownload?: () => void
  onShare?: () => void
}

export function ShareCenter({ caption, imageDataUrl, filename = 'promosi.png', onDownload, onShare }: ShareCenterProps) {
  const handleCopyCaption = async () => {
    if (!caption) {
      toast.error('Tidak ada caption')
      return
    }
    try {
      await copyText(caption)
      toast.success('Caption disalin')
    } catch {
      toast.error('Gagal menyalin caption')
    }
  }

  const handleDownload = () => {
    if (onDownload) {
      onDownload()
      return
    }
    if (imageDataUrl) {
      downloadDataUrl(imageDataUrl, filename)
      toast.success('Gambar diunduh')
    }
  }

  const handleShare = async () => {
    onShare?.()
    const text = caption || ''
    if (imageDataUrl) {
      try {
        const file = await dataUrlToFile(imageDataUrl, filename)
        const shared = await shareWithWebApi({ text, files: [file] })
        if (shared) {
          toast.success('Dibagikan')
          return
        }
      } catch {
        // fallback below
      }
    }
    const shared = await shareWithWebApi({ text, url: window.location.href })
    if (!shared && text) {
      await copyText(text)
      toast.success('Caption disalin — lanjutkan unggah manual di aplikasi pilihan Anda')
    } else if (shared) {
      toast.success('Dibagikan')
    } else {
      toast.info('Browser tidak mendukung Web Share API. Gunakan salin caption atau unduh gambar.')
    }
  }

  return (
    <div className="flex flex-wrap gap-2">
      {imageDataUrl && (
        <Button type="button" variant="outline" size="sm" onClick={handleDownload}>
          <Download className="w-4 h-4 mr-1" /> Download
        </Button>
      )}
      {caption && (
        <Button type="button" variant="outline" size="sm" onClick={handleCopyCaption}>
          <Copy className="w-4 h-4 mr-1" /> Copy Caption
        </Button>
      )}
      <Button type="button" size="sm" onClick={handleShare} className="bg-indigo-600 hover:bg-indigo-700 text-white">
        <Share2 className="w-4 h-4 mr-1" /> Bagikan
      </Button>
    </div>
  )
}
